module.exports = __webpack_public_path__ + "static/img/Akj-akin.69febc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Akj-akin.jpg
// module id = VXWo
// module chunks = 1